<template>
    <v-layout justify-center class="pagemargin page">
      <notifications group="update" position="top center" />
      <v-flex xs12 sm6 md3>
        <v-card-title primary-title>
          <notifications group="password-updated" position="top center" />

          <h4 class="headline mb-0">Update Password</h4>
        </v-card-title>
        <br />
        <v-form>
          <v-text-field
            :append-icon="show ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            hint="At least 8 characters"
            v-model.trim="Form.currentPassword"
            label="Current Password"
            solo
            data-vv-name="currentPassword"
            v-validate="'required|max:12'"
            :error-messages="errors.collect('currentPassword')"
            required
          ></v-text-field>

          <v-text-field
            :append-icon="show ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            hint="At least 8 characters"
            v-model.trim="Form.newPassword"
            label="New Password"
            solo
            data-vv-name="newPassword"
            v-validate="'required|max:12'"
            :error-messages="errors.collect('newPassword')"
            required
          ></v-text-field>

          <v-text-field
            :append-icon="show ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            hint="At least 8 characters"
            v-model.trim="Form.confirmNewPassword"
            label="Confirm New Password"
            solo
            data-vv-name="confirmNewPassword"
            v-validate="'required|max:12'"
            :error-messages="errors.collect('confirmNewPassword')"
            required
          ></v-text-field>

          <p class="mt-4">
            <center>
              <v-btn
                color="primary"
                :disabled="errors.any()"
                @click="updatePassword"
                round
                block
                class="caption font-weight-light"
              >Update Password</v-btn>
            </center>
          </p>
        </v-form>
      </v-flex>
    </v-layout>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      Form: {
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: ""
      },
      show: false,
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters"
      }
    };
  },
  methods: {
    updatePassword: function() {
      var user = this.$firebase.auth.currentUser;
      if (this.Form.confirmNewPassword === this.Form.newPassword) {
        this.$firebase.db
          .collection("users")
          .doc(user.uid)
          .update({
            password: this.Form.confirmNewPassword
          });

        user
          .updatePassword(this.Form.confirmNewPassword)
          .then(function() {
            // Update successful.

            Vue.notify({
              group: "update",
              title: "Success",
              text: "Your password has been updated.",
              type: "success"
            });
          })
          .catch(function() {
            Vue.notify({
              group: "update",
              title: "Error",
              text: "Something went wrong",
              type: "error"
            });
          });
      } else {
        Vue.notify({
          group: "update",
          title: "Warning",
          text: "Passwords do not match!",
          type: "warning"
        });
      }
    }
  }
};
</script>